import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { accountDetail } from '@/views/customer/accountManage/request';
import { editPersonalInformation } from './request';
import { isPhone, checkEmail } from '@/utils/validate';
import { editPersonalInformationCustomer } from './request2';
import topTitle from '@/components/title';
import mobileForm from './mobileForm.vue';
export default {
  components: {
    topTitle,
    mobileForm
  },
  data() {
    return {
      form: {
        nickName: '',
        mobile: '',
        userId: this.$route.params.id,
        account: '',
        email: '',
        password: undefined,
        globalRoaming: '+86'
      },
      visible: false,
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }]
    };
  },
  computed: {
    rules() {
      return {
        nickName: [{
          required: true,
          message: this.$t('请输入') + this.$t('管理员名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度应最少一位,最多一百位'),
          trigger: 'blur'
        }],
        account: [{
          required: true,
          trigger: 'blur',
          validator: this.validateAccount
        }, {
          min: 8,
          max: 50,
          message: this.$t('长度应最少八位,最多五十位'),
          trigger: 'blur'
        }],
        password: [{
          trigger: 'blur',
          validator: this.validatePassword
        }, {
          min: 8,
          max: 30,
          message: this.$t('长度应最少八位,最多三十位'),
          trigger: 'blur'
        }],
        email: [{
          required: false,
          trigger: 'blur',
          validator: this.validateEmail
        }],
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePhone
        }]
      };
    }
  },
  async mounted() {
    const res = await accountDetail({
      userId: this.$route.params.id
    });
    Object.assign(this.form, res);
  },
  methods: {
    validateEmail(rules, value, callback) {
      if (value && !checkEmail(value)) {
        callback(new Error(this.$t('邮箱格式有误，请重新填写')));
      }
      callback();
    },
    validateAccount(rules, value, callback) {
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('账号')));
      }
      let reg = /^[\w@._\-]+$/;
      if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字或特殊字符“@”和“.”“-”“_”')));
      }
      callback();
    },
    validatePassword(rules, value, callback) {
      let reg = /^\w+$/;
      if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字')));
      }
      callback();
    },
    validatePhone(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // 台湾
        HK: /^([6|9])\d{7}$/,
        // 香港
        MO: /^[6]\d{7}$/,
        // 澳门
        US: /^[1-9]\d{9}$/,
        // 美国
        SG: /^[89]\d{7}$/ // 新加坡
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.form.globalRoaming);
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      if (!regValue.test(value)) {
        callback(new Error(this.$t('手机号码有误，请重新填写')));
      } else {
        callback();
      }
    },
    openEditMobile() {
      this.visible = true;
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // if (this.form.mobile) {
          //   if (!isPhone(this.form.mobile)) {
          //     return this.$message.error('手机号码有误，请重新填写');
          //   }
          // }
          if (this.form.email) {
            if (!checkEmail(this.form.email)) {
              return this.$message.error(this.$t('邮箱有误，请重新填写'));
            }
          }
          let customerId = this.$store.state.user.accountInfo.customerId;
          if (customerId) {
            await editPersonalInformationCustomer(this.form);
          } else {
            await editPersonalInformation(this.form);
          }
          this.$router.push({
            name: 'index'
          });
        }
      });
    },
    saveMobileInfo(info) {
      this.form.globalRoaming = info.globalRoaming;
      this.form.mobile = info.mobile;
      this.visible = false;
    }
  }
};